export const triggerEventsTransform = ({ createdAt, ...rest }: any) => ({
  createdAt: createdAt.toDate(),
  ...rest,
});
